/* Document history: show only the newest file per invoice; older versions behind a "+N older" chip. */
import { useCallback, useRef, useState } from "react";

const keyOf = (e) => String(e.matched_invoice_no || e.invoice_no || "").trim().toUpperCase();
const tsOf = (e) => String(e.created_at || e.generated_at || "");

export const useLatestOnly = () => {
  const [open, setOpen] = useState(() => new Set());
  const meta = useRef({});
  const apply = useCallback((rows) => {
    const m = {};
    for (const r of rows) {
      const k = keyOf(r);
      if (!k) continue;
      const g = m[k] || (m[k] = { latest: r, n: 0 });
      g.n += 1;
      if (tsOf(r) > tsOf(g.latest)) g.latest = r;
    }
    meta.current = m;
    return rows.filter(r => { const k = keyOf(r); return !k || m[k].latest.id === r.id || open.has(k); });
  }, [open]);
  const toggle = (k) => setOpen(prev => { const n = new Set(prev); n.has(k) ? n.delete(k) : n.add(k); return n; });
  const chip = (entry, testId) => {
    const k = keyOf(entry);
    const g = k && meta.current[k];
    if (!g || g.n < 2) return null;
    if (g.latest.id !== entry.id) {
      return <span className="ml-1 text-[9px] font-semibold uppercase bg-slate-200 text-slate-600 px-1.5 py-0.5 rounded" data-testid={`older-tag-${testId}-${entry.id}`}>older</span>;
    }
    const on = open.has(k);
    return (
      <button type="button" onClick={() => toggle(k)} data-testid={`older-chip-${testId}-${entry.id}`}
        title={on ? "Hide older versions" : "Show older versions of this invoice (latest is final)"}
        className={`mx-1 text-[9px] font-bold px-1.5 py-0.5 rounded-full border transition-colors ${on ? "bg-slate-700 text-white border-slate-700" : "bg-white text-slate-600 border-slate-300 hover:bg-slate-100"}`}>
        {on ? "hide older" : `+${g.n - 1} older`}
      </button>
    );
  };
  return { apply, chip };
};
